<!-- src/components/AppLogo.vue -->
<template>
    <img :src="logo" alt="Taxscan Logo" class="logo" />
  </template>
  
  <script>
  import logoSrc from '@/assets/taxscanai-logo.png';
  export default {
    name: 'AppLogo',
    data() {
      return { logo: logoSrc };
    }
  };
  </script>
  
  <style scoped>
  .logo {
    max-width: 250px;
    margin-bottom: var(--space-md, 20px);
  }
  </style>
  